export default __webpack_public_path__ + "static/media/20230205_123332.6046d143.jpg";